import App from './App.html'
import {
  parse,
  compareAsc,
  addDays,
  isWeekend,
  isWednesday,
  isTuesday,
  isThursday
} from 'date-fns'

const readData = () => {
  const data = window.location.hash.substr(1)
  if (!data) {
    return 'Need data'
  }

  const bits = data.split('&').reduce((p, c) => {
    const [k, v] = c.split('=')
    p[k] = v
    return p
  }, {})

  const target = parse(bits.target)

  // const diff = differenceInCalendarDays(target, new Date())

  let days = 0
  let workingDays = 0
  let londonDays = 0
  let counter = new Date()
  let error = 1000

  while (error-- > 0 && compareAsc(counter, target) < 0) {
    days++

    if (!isWeekend(counter)) {
      workingDays++
    }

    if (isWednesday(counter) || isThursday(counter)) {
      londonDays++
    }
    counter = addDays(counter, 1)
  }

  return {
    display: `days: ${days} workingDays: ${workingDays} londonDays: ${londonDays}`
  }
}

const app = new App({
  target: document.body,
  data: readData()
})

setInterval(() => {
  app.set(readData())
}, 1000 * 60)

export default app
